import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconConsoleSparkle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="console-sparkle, Terminal"><path d="M20.25 12.5V3.75H3.75V20.25H12.5" stroke="currentColor" strokeWidth="1.5"/><path d="M18.4 14H17.6L16.6 16.6L14 17.6V18.4L16.6 19.4L17.6 22H18.4L19.4 19.4L22 18.4V17.6L19.4 16.6L18.4 14Z" fill="currentColor"/><path d="M6.75 7.75L8.5 9.5L6.75 11.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M10.75 11.25H12.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconConsoleSparkle;
